import types from 'actions/types';

const showConfirmModal = (message, confirmCallback, labelAccept, labelRefuse) => {
  return {
    type: types.SHOW_CONFIRM_MODAL,
    payload: { message, labelAccept, labelRefuse, confirmCallback },
  };
};

const hideConfirmModal = () => ({
  type: types.HIDE_CONFIRM_MODAL,
});

const triggerSidebar = (collapsedSideBar) => ({
  type: types.TRIGGER_SIDEBAR,
  payload: collapsedSideBar,
});

const showNotify = (payload) => ({
  type: types.SHOW_NOTIFY,
  payload: payload,
});

const hideNotify = () => ({
  type: types.HIDE_NOTIFY,
});

const showNotifyHeader = (payload) => async (dispatch) => {
  dispatch(hideNotify);
  dispatch(showNotify(payload));
};

export { showConfirmModal, hideConfirmModal, triggerSidebar, showNotify, hideNotify, showNotifyHeader };
